import { Injectable } from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {luminaria} from "../models/luminaria";
import {HttpClientService} from "./http-client.service";
import {Observable} from 'rxjs';
import {WebSocketService} from "./web-socket.service";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LuminariaService {

  selectedLumEdit: luminaria;

  constructor(private http: HttpClientService, private webSocketService: WebSocketService) { }

  public getAll() {
    return this.http.get('/luminaria/getall');
  }

  public getByID(id: string, includeDaliData: boolean) {
    let params = new HttpParams().set("luminariaID",id)
                                 .set("includeDaliData",includeDaliData + "");
    return this.http.getWithParams('/luminaria/getbyid', params);
  }

  public getByIdEmpresa(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa",idEmpresa);
    return this.http.getWithParams('/luminaria/getbyidempresa', params);
  }

  public getForDevicesPage(idEmpresa: string, page) {
    let params = new HttpParams().set("idEmpresa",idEmpresa).set("page",page);
    return this.http.getWithParams('/luminaria/getfordevicespage', params);
  }

  public getCountForDevicesPage(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa",idEmpresa);
    return this.http.getWithParams('/luminaria/getcountfordevicespage', params);
  }

  public getDaliDataPaginated(luminariaID: string, page: number, sortAscending: boolean) {
    let params = new HttpParams().set("luminariaID",luminariaID).set("page",page + "")
                                 .set("sortAscending",sortAscending + "");
    return this.http.getWithParams('/luminaria/getdalidatapaginated', params);
  }

  public getCountForDaliDataPaginated(luminariaID: string) {
    let params = new HttpParams().set("luminariaID",luminariaID);
    return this.http.getWithParams('/luminaria/getcountfordalidatapaginated', params);
  }

  public requestDaliData(idDispositivo: string): Observable<any> {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.postResponseJSON('/luminaria/requestdalidata', body).pipe(
      switchMap((response: any) => this.webSocketService.waitForDaliDataResponse(response.requestId))
    );
  }

  public requestPeripherals(idDispositivo: string): Observable<any> {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.postResponseJSON('/luminaria/requestperipherals', body).pipe(
      switchMap((response: any) => this.webSocketService.waitForPeripheralsResponse(response.requestId))
    );
  }

  public getByIdPlano(planoID: string) {
    let params = new HttpParams().set("planoId",planoID)
      .set("planoID",planoID + "");
    return this.http.getWithParams('/luminaria/getbyidplano', params);
  }

  public getByIdProyecto(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/luminaria/getbyidproyecto', params);
  }

  public getByIdProyectoWithPerifericos(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/luminaria/getbyidproyectowithperifericos', params);
  }

  public getByIdProyectoIdConcentrador(idProyecto: string, idConcentrador: string) {
    let params = new HttpParams().set("idConcentrador",idConcentrador).set("idProyecto",idProyecto);
    return this.http.getWithParams('/luminaria/getbyidproyectoandidconcentrador', params);
  }

  public mapUpdate(idDispositivo: string, nombre: string, idPlano: string, posicion_x: number, posicion_y: number, idZona: string) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "nombre": nombre,
        "idPlano": idPlano,
        "posicion_x": posicion_x,
        "posicion_y": posicion_y,
        "idZona": idZona
      };
    return this.http.patch('/luminaria/mapupdate', body);
  }

  public updateRotacion(idDispositivo: string, rotacion: number) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "rotacion": rotacion
      };
    return this.http.patch('/luminaria/update-rotacion', body);
  }

  public infoUpdate(idDispositivo: string, nombre: string, numSerie: string, fechaInstalacion: number, tieneEmergencia: boolean,
                    ledModelo: string, nominalLux: number, consumoPorHora: number, idProyecto: string, idPlano: string, idZona: string) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "nombre": nombre,
        "numSerie": numSerie,
        "fechaInstalacion": fechaInstalacion,
        "tieneEmergencia": tieneEmergencia,
        "ledModelo": ledModelo,
        "nominalLux": nominalLux,
        "consumoPorHora": consumoPorHora,
        "idProyecto": idProyecto,
        "idPlano": idPlano,
        "idZona": idZona
      };
    return this.http.patch('/luminaria/infoupdate', body);
  }

  public deleteRegistry(idDispositivo: string) {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.post('/luminaria/deleteregistry', body);
  }

  public deleteFull(idDispositivo: string) {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.post('/luminaria/deletefull', body);
  }

  public sendOrden(json: any) {
    this.http.post('/luminaria/sendorden', JSON.stringify(json)).subscribe(result => {
      console.log(result);
    });
  }

  public addFadeToLuminaria(idLuminaria: string, idFade: string) {

    let json =
      {
        "idLuminaria": idLuminaria,
        "idFade": idFade
      };

    return this.http.post('/luminaria/addfadetoluminaria', JSON.stringify(json));
  }

  public addLuminariesFromCSV(idUser, luminaries) {

    let json =
      {
        "idUser": idUser,
        "luminaries": luminaries
      };

    return this.http.post('/luminaria/addluminariesfromcsv', JSON.stringify(json));
  }

  downloadLuminariesCSV() {
    return this.http.getText('/luminaria/download-luminaries-csv');
  }

  setLumToEdit(lum: luminaria) {
    this.selectedLumEdit = lum;
  }

  getLumToEdit() {
    return this.selectedLumEdit;
  }

  public updateLedModelo(idDispositivo: string, ledModelo: string): Observable<any> {
    let body =
      {
        "idDispositivo": idDispositivo,
        "ledModelo": ledModelo
      };
    return this.http.patch('/luminaria/update-led-modelo', body);
  }

  public getIsErrorDaliDataByLuminaria(luminariaID: string) {
    let params = new HttpParams().set("luminariaID",luminariaID);
    return this.http.getWithParams('/luminaria/is-error-dalidata-by-luminaria', params);
  }

}
